














































import locationType from '@/store/types/location';
import { EnterpriceAddress as IntefaceEnterpriceAddress } from '@/store/interfaces/company';
import companyTypes from '@/store/types/company';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default Vue.extend({
  name: 'EnterpriseAddress',
  props: {
    update: {
      required: false,
      default: false,
      type: Boolean,
    },
    addressModel: {
      required: false,
      default: () => ({}),
      type: Object as PropType<IntefaceEnterpriceAddress>,
    },
  },
  data: () => ({
    address: {
      state_code: '',
      phone: '',
      description: '',
    } as IntefaceEnterpriceAddress,
  }),
  computed: {
    ...mapGetters({
      getListState: `country/${locationType.getters.GET_STATE}`,
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
  methods: {
    ...mapMutations({
      setAddress: `companyModule/${companyTypes.mutations.SET_ADDRESS}`,
    }),
    ...mapActions({
      ListState: `country/${locationType.actions.STATE_LIST}`,
    }),
    assignAddress(): void {
      this.address = this.update
        ? this.addressModel
        : this.getNewCompanyParams.address;
    },
  },
  watch: {
    address: {
      immediate: true,
      deep: true,
      handler(val: IntefaceEnterpriceAddress): void {
        setTimeout(() => {
          if (this.update) {
            this.$emit('update:addressModel', val);
          } else {
            this.setAddress(val);
          }
        }, 500);
      },
    },
  },
  async mounted(): Promise<void> {
    await this.ListState('SV');
    this.assignAddress();
  },
});
